import { useCallback, useState } from "react";
import { TSetor } from "../../../../../types/api/estoque/setores";
import SessaoConfiguracao from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";
import DialogCriacaoEditSetores from "./DialogCriacaoEditSetores";

export default function Setores() {

   const [openModal, setOpenModal] = useState<TOpenModalSetores>(null)
 
   //funções manipuladoras
   const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: TSetor | null) => {
     if (action === "close") setOpenModal(null)
     if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
     if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
   }, [])
   //

  return (
    <>
      <SessaoConfiguracao<TSetor>
        titulo="Setores"
        endpoints={{
          listar: "estoque/pesquisar-setores",
          deletar: "estoque/configuracoes/excluir-setor",
        }}
        colunas={colunas}
        queryKey="pesquisar-setores"
        onEditar={(setor) => {
          handleModalAction("open", setor.id, setor)
        }}
        onAdicionar={() => {
          handleModalAction("open", true, null)
        }}
        mensagemSucessoDeletar="Setor deletado com sucesso!"
        mensagemErroDeletar="Erro ao deletar setor!"
        mensagemSemDados="Nenhum setor encontrado."
      />
      {
        Boolean(openModal?.open) &&
        <DialogCriacaoEditSetores
          defaultValue={openModal?.defaultValue ? openModal : null}
          open={Boolean(openModal?.open)}
          handleClose={() => handleModalAction("close")}
        />
      }
    </>
  );
}

export type TOpenModalSetores = {
  open: number | boolean | null;
  defaultValue: TSetor | null;
} | null

const colunas = [
  {
    campo: "nome" as keyof TSetor,
    titulo: "Nome",
  },
];
